// Shared pricing logic used across all pages and mock API
// Rule: always daily rate, ceil partial days, then add 18% GST

export const GST_RATE = 0.18;

// Calculate number of days (ceil any partial day)
// e.g. 1 day 5 hrs = ceil(29/24) = 2 days
export const calcDays = (startTime, endTime) => {
  const hours = (new Date(endTime) - new Date(startTime)) / (1000 * 60 * 60);
  return Math.ceil(hours / 24) || 1;
};

// Base amount before GST (days x daily rate)
export const calcBase = (bike, startTime, endTime) => {
  const days = calcDays(startTime, endTime);
  return days * bike.price_per_day;
};

// GST amount
export const calcGST = (baseAmount) => Math.round(baseAmount * GST_RATE * 100) / 100;

// Full breakdown object used everywhere
export const calcPricing = (bike, startTime, endTime, discountAmount = 0) => {
  const days           = calcDays(startTime, endTime);
  const base           = days * bike.price_per_day;
  const afterDiscount  = Math.max(0, base - discountAmount);
  const gst            = calcGST(afterDiscount);
  const total          = afterDiscount + gst;
  return { days, base, discountAmount, afterDiscount, gst, total };
};

export const fmt = (n) => `\u20B9${Number(n).toFixed(2)}`;
